import { IconWithKey } from './IconWithKey';
import './InterfaceShortcuts.scss';

export const InterfaceShortcuts = () => {
  return (
    <div className="interface-shortcuts">
      <IconWithKey
        sprite={'inventory-icon'}
        context="dungeon"
        action="INVENTORY"
        size={43}
        title="Inventaire"
      />
      <IconWithKey
        sprite={'map-icon'}
        context="dungeon"
        action="OPEN_MAP"
        size={43}
        title="Carte"
      />
      <IconWithKey
        sprite={'option-icon'}
        context="dungeon"
        action="PAUSE"
        size={43}
        title="Options"
      />
    </div>
  );
};
